interface MacroBarsProps {
  readonly proteinG: number;
  readonly carbsG: number;
  readonly fatG: number;
}

/** Three staggered macro bars growing from zero; used on the first benefit interstitial. */
export function MacroBars({ proteinG, carbsG, fatG }: MacroBarsProps) {
  const rows = [
    { label: "Protein", grams: proteinG, kcal: proteinG * 4 },
    { label: "Carbs", grams: carbsG, kcal: carbsG * 4 },
    { label: "Fat", grams: fatG, kcal: fatG * 9 },
  ];
  const maxKcal = Math.max(...rows.map((row) => row.kcal), 1);

  return (
    <div className="flex flex-col gap-2.5 rounded-2xl border border-border bg-surface p-3.5">
      {rows.map((row, index) => (
        <div key={row.label} className="flex flex-col gap-1">
          <div className="flex items-baseline justify-between">
            <span className="text-sm font-semibold text-text">{row.label}</span>
            <span className="text-sm tabular-nums text-text-muted">{row.grams} g</span>
          </div>
          <div className="h-2.5 w-full overflow-hidden rounded-full bg-muted">
            <div
              className="ob-bar-grow h-full rounded-full bg-accent"
              style={{
                width: `${Math.round((row.kcal / maxKcal) * 100)}%`,
                animationDelay: `${index * 140}ms`,
                opacity: 1 - index * 0.25,
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
